/**
 * is-electron
 *
 * Checks to see if the app is running within Electron.
 * Does a boolean check on if `window.process.type` exists.
 */

export default function() {
  return !!(window && window.process && window.process.type);
};



// WEBPACK FOOTER //
// ./src/utils/is-electron.js